import store from '@/stores';
import { fetchUserPoints2 } from '@/stores/slice/user';

export function updatePointsDelay(t = 2000) {
  setTimeout(() => {
    store.dispatch(fetchUserPoints2());
  }, t);
}

